import type {
  BlocoAguardando,
  BlocoContagem,
  BlocoRankingVelocidade,
  Dashboard,
  EnvelopeAgregado,
  Funil,
  RelatorioPerdas,
} from '@baiocchi/shared'

import { api, type ParametrosConsulta } from './cliente'

/**
 * `/indicadores` e `/conversoes` (`05-dashboard-metrics.md`).
 *
 * Toda resposta vem no envelope `{ dados, meta }`, e `meta.atualizadoEm` é
 * **obrigatório** (RNF-80): a tela precisa datar o número, porque um dia a
 * origem passa a ser a matview e o valor terá defasagem. O carimbo já existe
 * hoje, com `defasagemMinutos: 0`, e é por isso que a troca não muda o contrato.
 */
export const indicadoresApi = {
  dashboard(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<Dashboard>>('/indicadores/dashboard', filtros, sinal)
  },

  recebidos(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<BlocoContagem>>('/indicadores/recebidos', filtros, sinal)
  },

  aguardando(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<BlocoAguardando>>('/indicadores/aguardando', filtros, sinal)
  },

  /**
   * O ranking também vem dentro de `dashboard`. Esta rota existe para quem precisa
   * dele isolado (recarregar só o bloco) sem repetir as sete agregações da tela.
   */
  rankingVelocidade(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<BlocoRankingVelocidade>>(
      '/indicadores/ranking-velocidade',
      filtros,
      sinal,
    )
  },
}

export const conversoesApi = {
  funil(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<Funil>>('/conversoes/funil', filtros, sinal)
  },

  perdas(filtros?: ParametrosConsulta, sinal?: AbortSignal) {
    return api.get<EnvelopeAgregado<RelatorioPerdas>>('/conversoes/perdas', filtros, sinal)
  },
}
